import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
export function ProjectFilterPills() {
  const {
    selectedProjects,
    toggleProject
  } = useProjectFilter();
  const allProjectsSelected = selectedProjects.length === AVAILABLE_PROJECTS.length;
  if (allProjectsSelected) return null;
  return <motion.div initial={{
    opacity: 0,
    y: -10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex flex-wrap items-center gap-2 mt-3" data-id="element-3000" data-mp="3jg60gjeioge5">
      <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-3001" data-mp="3t83ahmtsh2ba">
        Viewing:
      </span>
      <AnimatePresence mode="popLayout" data-id="element-3002" data-mp="1zo1mxnreiee">
        {selectedProjects.map(project => <motion.div key={project} initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.2
      }} className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-3 py-1.5 rounded-full text-sm font-medium border border-emerald-200" data-id="element-3003" data-mp="63nijhcybj8a">
            <span data-id="element-3004" data-mp="2wxzqflqno18">{project}</span>
            <button onClick={() => toggleProject(project)} className="hover:bg-emerald-100 rounded-full p-0.5 transition-colors" aria-label={`Remove ${project}`} data-id="element-3005" data-mp="2vwfplmqvr7d">
              <X size={14} data-id="element-3006" data-mp="3paxyx3cg6sxd" />
            </button>
          </motion.div>)}
      </AnimatePresence>
    </motion.div>;
}